var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../auth";
import { useToast } from "@reverb-ui/react";
export var ClientEmployeeContext = React.createContext({
    loading: false,
    employee: null,
    client: null,
    clientContacts: [],
    clientAddresses: [],
    handleClientChange: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/];
    }); }); },
    isOwnerOrAdminOfClient: function () { return false; },
    employeeClientsOwnedOrAdministrated: function () { return null; },
    employeeClients: function () { return []; },
    submitAddresses: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/];
    }); }); },
    submitContacts: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/];
    }); }); },
    submitInformation: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/];
    }); }); },
    defaultValueEmployeeClient: function () { return null; },
    getAllContractsByClientRockId: function () { return Promise.resolve(); },
    responsiblesClientContracts: [],
});
export var ClientEmployeeProvider = function (_a) {
    var children = _a.children, entityRepository = _a.entityRepository, contactRepository = _a.contactRepository, addressRepository = _a.addressRepository, contractRepository = _a.contractRepository;
    var toast = useToast();
    var _b = useContext(AuthContext), rockId = _b.rockId, clientWallets = _b.clientWallets;
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState(), employee = _d[0], setEmployee = _d[1];
    var _e = useState(null), client = _e[0], setClient = _e[1];
    var _f = useState([]), clientContacts = _f[0], setClientContacts = _f[1];
    var _g = useState([]), clientAddresses = _g[0], setClientAddresses = _g[1];
    var _h = useState([]), responsiblesClientContracts = _h[0], setResponsiblesClientContracts = _h[1];
    var requestEmployeeData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var emp, selectedClient, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, entityRepository.getEmployeesDetailed(rockId)];
                case 2:
                    emp = _b.sent();
                    selectedClient = emp.clients.find(function (c) { return c.rockId === clientWallets[0].rockId; });
                    setClient(selectedClient);
                    setEmployee(emp);
                    return [2 /*return*/, emp];
                case 3:
                    _a = _b.sent();
                    throw new Error("Failed to fetch employee data");
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleClientChange = function () { return __awaiter(void 0, void 0, void 0, function () {
        var contacts, addresses, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, contactRepository.getContacts("clients", client.rockId)];
                case 2:
                    contacts = _b.sent();
                    return [4 /*yield*/, addressRepository.getAddresses("clients", client.rockId)];
                case 3:
                    addresses = _b.sent();
                    setClient(client);
                    setClientContacts(contacts);
                    setClientAddresses(addresses);
                    return [3 /*break*/, 6];
                case 4:
                    _a = _b.sent();
                    throw new Error("Failed to fetch contact and addresses data");
                case 5:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var employeeClientsOwnedOrAdministrated = function () {
        if (!client)
            return null;
        var clientIsOwner = client.roles.includes("employee::owner");
        var clientIsAdmin = client.roles.includes("employee::admin");
        return clientIsOwner || clientIsAdmin ? client : null;
    };
    var employeeClients = function () {
        var _a;
        if (!((_a = employee === null || employee === void 0 ? void 0 : employee.clients) === null || _a === void 0 ? void 0 : _a.length))
            return [];
        return employee.clients;
    };
    var defaultValueEmployeeClient = function () {
        if (client) {
            var rockId_1 = client.rockId, name_1 = client.name;
            return {
                value: rockId_1,
                label: name_1,
                locationId: client === null || client === void 0 ? void 0 : client.location.id,
            };
        }
        return null;
    };
    var isOwnerOrAdminOfClient = function () {
        return !!employeeClientsOwnedOrAdministrated();
    };
    var postAddresses = function (addresses) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    if (!(addresses && addresses.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, addressRepository.postAddresses("clients", client.rockId, addresses)];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    throw new Error("Failed to create addresses");
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var patchAddresses = function (addresses) { return __awaiter(void 0, void 0, void 0, function () {
        var promises, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    if (!(addresses && addresses.length > 0)) return [3 /*break*/, 2];
                    promises = addresses.map(function (address) {
                        return addressRepository.patchAddress("clients", client.rockId, address);
                    });
                    return [4 /*yield*/, Promise.all(promises)];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    throw new Error("Failed to update addresses");
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var deleteAddresses = function (addressesId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    if (!(addressesId && addressesId.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, addressRepository.deleteAddresses("clients", client.rockId, addressesId)];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    throw new Error("Failed to delete addresses");
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var submitAddresses = function (addressesToDelete, addressesToUpdate, addressesToCreate) { return __awaiter(void 0, void 0, void 0, function () {
        var addresses, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, , 6]);
                    return [4 /*yield*/, deleteAddresses(addressesToDelete)];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, patchAddresses(addressesToUpdate)];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, postAddresses(addressesToCreate)];
                case 3:
                    _b.sent();
                    return [4 /*yield*/, addressRepository.getAddresses("clients", client.rockId)];
                case 4:
                    addresses = _b.sent();
                    setClientAddresses(addresses);
                    return [3 /*break*/, 6];
                case 5:
                    _a = _b.sent();
                    throw new Error("Failed to submit addresses");
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var postContacts = function (contacts) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    if (!(contacts && contacts.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, contactRepository.postContacts("clients", client.rockId, contacts)];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    throw new Error("Failed to create contacts");
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var patchContacts = function (contacts) { return __awaiter(void 0, void 0, void 0, function () {
        var promises, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    if (!(contacts && contacts.length > 0)) return [3 /*break*/, 2];
                    promises = contacts.map(function (contact) {
                        return contactRepository.patchContact("clients", client.rockId, contact);
                    });
                    return [4 /*yield*/, Promise.all(promises)];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    throw new Error("Failed to update contacts");
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var deleteContacts = function (contactsId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    if (!(contactsId && contactsId.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, contactRepository.deleteContacts("clients", client.rockId, contactsId)];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    throw new Error("Failed to delete contacts");
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var submitContacts = function (contactsToDelete, contactsToUpdate, contactsToCreate) { return __awaiter(void 0, void 0, void 0, function () {
        var contacts, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, , 6]);
                    return [4 /*yield*/, deleteContacts(contactsToDelete)];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, patchContacts(contactsToUpdate)];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, postContacts(contactsToCreate)];
                case 3:
                    _b.sent();
                    return [4 /*yield*/, contactRepository.getContacts("clients", client.rockId)];
                case 4:
                    contacts = _b.sent();
                    setClientContacts(contacts);
                    return [3 /*break*/, 6];
                case 5:
                    _a = _b.sent();
                    throw new Error("Failed to submit contacts");
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var pathClientInformation = function (clientInformationToUpdate) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, entityRepository.updateClient(client.rockId, clientInformationToUpdate)];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    throw new Error("Failed to update contacts");
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var submitInformation = function (clientInformationToUpdate) { return __awaiter(void 0, void 0, void 0, function () {
        var clientRockId_1, newEmp, selectedClient, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    clientRockId_1 = client.rockId;
                    return [4 /*yield*/, pathClientInformation(clientInformationToUpdate)];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, requestEmployeeData()];
                case 2:
                    newEmp = _b.sent();
                    selectedClient = newEmp.clients.find(function (c) { return c.rockId === clientRockId_1; });
                    setClient(selectedClient);
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    throw new Error("Failed to submit contacts");
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var setClientsResponsibles = function (contracts) {
        var responsibles = contracts
            .filter(function (contract) { return contract.isActive; })
            .reduce(function (responsibles, contractActive) {
            return contractActive.responsibles;
        }, []);
        setResponsiblesClientContracts(responsibles);
    };
    var getAllContractsByClientRockId = function (clientRockId, withChurn) {
        if (withChurn === void 0) { withChurn = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                setLoading(true);
                contractRepository
                    .getAllContractsByClientId(clientRockId, withChurn)
                    .then(function (contracts) {
                    setClientsResponsibles(contracts);
                })
                    .catch(function (error) {
                    toast({
                        status: "error",
                        title: error,
                        duration: 5000,
                    });
                })
                    .finally(function () {
                    setLoading(false);
                });
                return [2 /*return*/];
            });
        });
    };
    useEffect(function () {
        if (!rockId)
            return;
        requestEmployeeData();
    }, [rockId]);
    useEffect(function () {
        if (client)
            handleClientChange();
    }, [client]);
    return (React.createElement(ClientEmployeeContext.Provider, { value: {
            loading: loading,
            employee: employee,
            client: client,
            clientContacts: clientContacts,
            clientAddresses: clientAddresses,
            handleClientChange: handleClientChange,
            isOwnerOrAdminOfClient: isOwnerOrAdminOfClient,
            employeeClientsOwnedOrAdministrated: employeeClientsOwnedOrAdministrated,
            submitAddresses: submitAddresses,
            submitContacts: submitContacts,
            submitInformation: submitInformation,
            employeeClients: employeeClients,
            defaultValueEmployeeClient: defaultValueEmployeeClient,
            getAllContractsByClientRockId: getAllContractsByClientRockId,
            responsiblesClientContracts: responsiblesClientContracts,
        } }, children));
};
